<template>
  <div class="ccui-app-box-iframe-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <!--    <div class="detail-info-el-Label">-->
    <!--      <el-label :type="labelType" style="height: 100px;"></el-label>-->
    <!--    </div>-->
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <!-- <div v-if="relationWarningList.length > 0" class="tips">
          <div style="color: red">温馨提示：</div>
          <div v-for="(item, index) in relationWarningList" :key="index">
            {{ item }}
          </div>
        </div> -->
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane
            :label="type == 0 ? '技术评分汇总' : '商务技术评分汇总'"
            name="1"
          >
            <template v-if="supPackFlag">
              <el-tabs class="customeTab" v-model="active">
                <el-tab-pane
                  v-for="(listItem, listIndex) in listData"
                  :key="listItem.packId"
                  :label="listItem.packName"
                  :name="'' + listIndex"
                >
                  <el-table
                    :data="listItem.data"
                    border
                    max-height="460"
                    :span-method="spanMethod"
                  >
                    <el-table-column
                      v-for="(item, index) in listItem.columns"
                      :key="index"
                      :fixed="item.fixed"
                      :min-width="item.width"
                      :header-align="item.money ? 'center' : ''"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                    >
                      <template
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          align="center"
                          v-bind="child"
                        >
                          <template slot="header">
                            <div class="el-tooltip">{{ child.label }}</div>
                          </template>
                          <template
                            v-if="
                              child.labelChild && child.labelChild.length > 0
                            "
                          >
                            <el-table-column
                              v-for="(childs, indexch) in child.labelChild"
                              :key="indexch"
                              align="center"
                              :prop="childs.prop"
                            >
                              <template slot="header">
                                <div
                                  :title="childs.label"
                                  class="el-tooltip tooltip-header"
                                  :class="{
                                    'tooltip-header-flow':
                                      childs.label.length > 15
                                  }"
                                >
                                  {{ childs.label }}
                                </div>
                              </template>
                              <!--<template slot="header">-->
                              <!--<div class="el-tooltip">-->
                              <!--{{ "细则权重:" + childs.label1 }}-->
                              <!--</div>-->
                              <!--</template>-->
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                      <template slot-scope="scope">
                        <span v-if="item.money">{{
                          scope.row[item.prop]
                            ? new BigNumber(scope.row[item.prop]).toFormat(2)
                            : ""
                        }}</span>
                        <el-button
                          v-else-if="item.type == 'AIbtn'"
                          size="mini"
                          type="text"
                          @click="toAI(scope.row)"
                          >{{
                            scope.row[item.prop]
                              ? new BigNumber(scope.row[item.prop]).toFormat(2)
                              : ""
                          }}</el-button
                        >
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
            <template v-else>
              <div v-for="(listItem, listIndex) in listData" :key="listIndex">
                <el-table
                  :data="listItem.data"
                  max-height="460"
                  border
                  :span-method="spanMethod"
                >
                  <el-table-column
                    v-for="(item, index) in listItem.columns"
                    :key="index"
                    :min-width="item.width"
                    :fixed="item.fixed"
                    :header-align="item.money ? 'center' : ''"
                    :show-overflow-tooltip="true"
                    width="130px"
                    v-bind="item"
                  >
                    <template
                      v-if="item.labelChild && item.labelChild.length > 0"
                    >
                      <el-table-column
                        v-for="(child, indexch) in item.labelChild"
                        :key="indexch"
                        align="center"
                        v-bind="child"
                      >
                        <template slot="header">
                          <div class="el-tooltip">{{ child.label }}</div>
                        </template>
                        <template
                          v-if="child.labelChild && child.labelChild.length > 0"
                        >
                          <el-table-column
                            v-for="(childs, indexch) in child.labelChild"
                            :key="indexch"
                            align="center"
                            :prop="childs.prop"
                          >
                            <template slot="header">
                              <div
                                :title="childs.label"
                                class="el-tooltip tooltip-header"
                                :class="{
                                  'tooltip-header-flow':
                                    childs.label.length > 15
                                }"
                              >
                                {{ childs.label }}
                              </div>
                            </template>
                            <!--<template slot="header">-->
                            <!--<div class="el-tooltip">-->
                            <!--{{ "细则权重:" + childs.label1 }}-->
                            <!--</div>-->
                            <!--</template>-->
                          </el-table-column>
                        </template>
                      </el-table-column>
                    </template>
                    <template slot-scope="scope">
                      <span v-if="item.money">{{
                        scope.row[item.prop]
                          ? new BigNumber(scope.row[item.prop]).toFormat(2)
                          : ""
                      }}</span>
                      <el-button
                        v-else-if="item.type == 'AIbtn'"
                        size="mini"
                        type="text"
                        @click="toAI(scope.row)"
                        >{{
                          scope.row[item.prop]
                            ? new BigNumber(scope.row[item.prop]).toFormat(2)
                            : ""
                        }}</el-button
                      >
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="operate">
      <el-button
        type="text"
        icon="icon-ccui-return"
        @click="dealExpertSupScoreCancel"
        >撤销评分</el-button
      >
      <!--      <template v-if="listData[active].summaryTableData.length === 0">-->
      <el-button
        type="text"
        icon="icon-ccui-data"
        v-preventReClick
        @click="operateSummary"
        >汇总</el-button
      >
      <!--      </template>-->
      <!--      <template v-if="listData[active].summaryTableData.length > 0">-->
      <!--      <el-button-->
      <!--        type="text"-->
      <!--        icon="el-icon-refresh-right"-->
      <!--        @click="operateSummary"-->
      <!--        >重新汇总</el-button-->
      <!--      >-->
      <!--      </template>-->
      <!--      <el-button type="text" icon="icon-ccui-agree" @click="dealSumScoreSubmit"-->
      <!--        >提交</el-button-->
      <!--      >-->
      <el-button type="text" icon="icon-ccui-sharing-o" @click="refresh"
        >刷新</el-button
      >
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="供应商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supPackQuoteId="formData.supPackQuoteId"
        :supQuoteId="formData.supQuoteId"
        :supCode="formData.supCode"
      ></supplierBidDetails>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from "ccui";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qrySumScorePackListApi,
  qrySumScoreExpertScoreListApi,
  qryNotSubmitScoreExpertListApi,
  dealExpertSupScoreCancelApi,
  dealSumScoreSubmitApi,
  qryBidEvaProcessStatusApi,
  bidSupPersonnelRelationWarning
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import BigNumber from "bignumber.js";
export default {
  name: "noSummary",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  props: {
    type: {
      type: Number, // 0: 技术评分汇总 1：商务技术评分汇总
      default: 0
    }
  },
  data() {
    return {
      BigNumber: BigNumber,
      breadcrumbData: {
        titname: this.type == 0 ? "技术评分汇总" : "商务技术评分汇总",
        status: "未汇总"
      },
      labelType: "NotSummary",
      dialogVisible: false,
      listData: [],
      relationWarningList: [],
      active: "0",
      skillHeaders: [],
      commonHeader: [],
      formData: {
        supQuoteId: "",
        supPackQuoteId: "",
        supCode: ""
      },
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
        },
        {
          prop: "expertName",
          label: "评分专家",
          width: 170,
          fixed: true
        },
        {
          prop: "supName",
          label: "供应商",
          width: 200,
          fixed: true
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 90
        },
        // {
        //   prop: "aiSumScore",
        //   label: "AI打分汇总",
        //   width: 110,
        //   type: "AIbtn"
        // },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 260
        },
        {
          prop: "updateTime",
          label: "评分提交时间",
          width: 170
        }
      ],
      evaForm: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaForm, // 1：技术商务组合评分 2：技术商务分开评分
      supPackFlag: false, // 是否分包件 false:不分包
      purchaseType: ""
    };
  },
  created() {
    this.$route.query.active && (this.active = this.$route.query.active);
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.columnCopy.splice(6, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.getData();
    this.getSupPersonnelRelationWarning();
  },
  methods: {
    getData() {
      qrySumScorePackListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        sumScoreType: this.type == 0 ? "0" : this.evaForm == "1" ? "2" : "1" // 技术商务评分汇总并且组合评分的时候才查询技术商务，分开评分的时候只查询商务
        // sumScoreType: this.type == 0 ? "0" :"2" // 技术商务评分汇总并且组合评分的时候才查询技术商务，分开评分的时候只查询商务
      }).then(res => {
        this.supPackFlag = res.data.data.supPackFlag;
        let arr = [];
        if (res.data.data.supPackFlag) {
          res.data.data.notSumScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(
                this.qrySumScoreExpertScoreList(item.packId, item.packName)
              );
            }
          });
        } else {
          arr.push(this.qrySumScoreExpertScoreList("", ""));
        }
        Promise.all(arr).then(res1 => {
          if (res1 && res1.length > 0) {
            // 通过包件id进行排序
            res1.sort(function(a, b) {
              if (a.joinExpertId > b.joinExpertId) {
                return 1;
              } else if (a.joinExpertId < b.joinExpertId) {
                return -1;
              } else {
                return 0;
              }
            });
            res1.forEach((item, index) => {
              item.columns = JSON.parse(JSON.stringify(this.columns));
              // 技术评分汇总
              if (this.type == 0) {
                item.columns.splice(7, 0, {
                  prop: "sscScoreItemBOS",
                  label: "技术",
                  labelChild: [],
                  align: "center"
                });
              }
              // 技术商务评分汇总
              if (this.type == 1) {
                if (this.evaForm == "1") {
                  // 组合评分
                  item.columns.splice(7, 0, {
                    prop: "sscScoreItemBOS",
                    label: "技术",
                    labelChild: [],
                    align: "center"
                  });
                  item.columns.splice(8, 0, {
                    prop: "sscCommonScoreItemBOS",
                    label: "商务",
                    labelChild: [],
                    align: "center"
                  });
                }
                if (this.evaForm == "2") {
                  // 分开评分
                  item.columns.splice(7, 0, {
                    prop: "sscCommonScoreItemBOS",
                    label: "商务",
                    labelChild: [],
                    align: "center"
                  });
                }
              }
              let skillChild = []; // 技术评分的表头
              let commonChild = []; // 商务评分的表头
              let devspan = 0; // 之前行的数
              let data = []; // 数据
              let id = 0; // 序号
              item.expertList.forEach((aItem, aIndex) => {
                id++;
                if (aIndex > 0) {
                  devspan +=
                    item.expertList[aIndex - 1].sscSupQuoteScoreBOS.length;
                  // item.expertList[aIndex - 1].sscSupQuoteScoreBOS.forEach(a => {
                  //   devspan += a.sscSupScoreBOS.length;
                  // });
                }
                aItem.sscSupQuoteScoreBOS.forEach((bItem, bIndex) => {
                  bItem.supScore = bItem.supScore
                    ? new BigNumber(bItem.supScore).toFormat(2)
                    : bItem.supScore;
                  let columnCount = 10; // 总共有多少列，用于计算最后一列的合并
                  bItem.sscSupScoreBOS.forEach(b => {
                    columnCount += b.sscSupScoreItemBOS.length;
                  });
                  let obj = {
                    id: id,
                    joinExpertId: aItem.joinExpertId,
                    taskId: bItem.taskId,
                    expertName: aItem.expertName,
                    supJoinId: bItem.supJoinId,
                    supQuoteId: bItem.supQuoteId,
                    supCode: bItem.supCode,
                    supName: bItem.supName,
                    priceAmount: bItem.priceAmount,
                    supScore: bItem.supScore,
                    aiSumScore: bItem.aiSumScore,
                    scoreDesc: bItem.scoreDesc,
                    updateTime: bItem.updateTime,
                    devspan: devspan,
                    rowspan: aItem.sscSupQuoteScoreBOS.length,
                    columnCount: columnCount,
                    industryTypeName: bItem.industryTypeName,
                    companyTypeName: bItem.companyTypeName,
                    supCategoryName: bItem.supCategoryName,
                    supLevelName: bItem.supLevelName,
                    supTypeNewName: bItem.supTypeNewName
                  };
                  bItem.sscSupScoreBOS.forEach((cItem, cIndex) => {
                    cItem.sscSupScoreItemBOS.forEach((dItem, dIndex) => {
                      obj.scoreRule = dItem.scoreRule;
                      let props =
                        "supScore-" + cItem.scoreItem + "-" + dItem.scoreItemId;
                      obj[props] = dItem.supScore
                        ? new BigNumber(dItem.supScore).toFormat(2)
                        : dItem.supScore;
                      if (this.type == 0) {
                        // 技术评分汇总
                        if (cItem.scoreItem === "0") {
                          if (
                            skillChild.filter(item => {
                              return (
                                item.prop ==
                                "supScore-" +
                                  cItem.scoreItem +
                                  "-" +
                                  dItem.scoreItemId
                              );
                            }).length == 0
                          ) {
                            skillChild.push({
                              prop: props,
                              label: dItem.scoreRule,
                              label1: dItem.scoreWeight,
                              width: 120,
                              labelChild: [
                                {
                                  prop: props,
                                  label: "细则权重:" + dItem.scoreWeight,
                                  width: 280,
                                  money: true
                                }
                              ]
                            });
                          }
                        }
                      }
                      if (this.type == 1) {
                        // 技术商务评分汇总
                        if (this.evaForm == "1") {
                          // 技术商务组合评分
                          if (cItem.scoreItem === "0") {
                            if (
                              skillChild.filter(item => {
                                return (
                                  item.prop ==
                                  "supScore-" +
                                    cItem.scoreItem +
                                    "-" +
                                    dItem.scoreItemId
                                );
                              }).length == 0
                            ) {
                              skillChild.push({
                                prop: props,
                                label: dItem.scoreRule,
                                label1: dItem.scoreWeight,
                                width: 120,
                                labelChild: [
                                  {
                                    prop: props,
                                    label: "细则权重:" + dItem.scoreWeight,
                                    width: 280,
                                    money: true
                                  }
                                ]
                              });
                            }
                          }
                          if (cItem.scoreItem === "1") {
                            if (
                              commonChild.filter(item => {
                                return (
                                  item.prop ==
                                  "supScore-" +
                                    cItem.scoreItem +
                                    "-" +
                                    dItem.scoreItemId
                                );
                              }).length == 0
                            ) {
                              commonChild.push({
                                prop: props,
                                label: dItem.scoreRule,
                                label1: dItem.scoreWeight,
                                width: 120,
                                labelChild: [
                                  {
                                    prop: props,
                                    label: "细则权重:" + dItem.scoreWeight,
                                    width: 280,
                                    money: true
                                  }
                                ]
                              });
                            }
                          }
                        }
                        // 技术商务分开评分
                        if (this.evaForm == "2") {
                          if (cItem.scoreItem === "1") {
                            if (
                              commonChild.filter(item => {
                                return (
                                  item.prop ==
                                  "supScore-" +
                                    cItem.scoreItem +
                                    "-" +
                                    dItem.scoreItemId
                                );
                              }).length == 0
                            ) {
                              commonChild.push({
                                prop: props,
                                label: dItem.scoreRule,
                                label1: dItem.scoreWeight,
                                width: 120,
                                labelChild: [
                                  {
                                    prop: props,
                                    label: "细则权重:" + dItem.scoreWeight,
                                    width: 280,
                                    money: true
                                  }
                                ]
                              });
                            }
                          }
                        }
                      }
                    });
                  });
                  data.push(obj);
                });
              });
              if (skillChild.length + commonChild.length < 3) {
                if (this.type == 1) {
                  delete item.columns[9].width;
                } else {
                  delete item.columns[9].width;
                }
              }
              if (this.type == 0) {
                item.columns[7].labelChild = skillChild;
              }
              console.log(skillChild, commonChild);
              if (this.type == 1) {
                if (this.evaForm == "1") {
                  // 组合评分
                  item.columns[7].labelChild = skillChild;
                  item.columns[8].labelChild = commonChild;
                }
                if (this.evaForm == "2") {
                  // 组合评分
                  item.columns[7].labelChild = commonChild;
                }
              }
              item.data = data;
              if (!item.data[0].taskId) {
                item.columns = item.columns.filter(
                  item => item.props != "aiSumScore"
                );
              }
            });
          }
          this.listData = res1;
        });
      });
    },
    toAI(row) {
      let baseUrl = "http://47.108.13.132:8102";
      if (window.location.host.indexOf("local") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("test01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("uat01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else {
        baseUrl = "https://aimarket.iccec.cn";
      }
      window.open(
        baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=true&step=1&token=" +
          sessionStorage.getItem("AItoken") +
          "&tech=" +
          (this.type == 0 ? true : false),
        "_blank"
      );
    },
    getSupPersonnelRelationWarning() {
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        step: "6",
        languageFlag: ""
      };
      bidSupPersonnelRelationWarning(param).then(res => {
        if (res.data.code == "0") {
          this.relationWarningList = res.data.data.compareResult;
        }
      });
    },
    qrySumScoreExpertScoreList(packId, packName) {
      return new Promise((resolve, reject) => {
        qrySumScoreExpertScoreListApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          scoreItem: this.type == 0 ? "0" : this.evaForm == "1" ? "" : "1"
        }).then(res => {
          let obj = {
            packId: packId,
            packName: packName,
            expertList: res.data.data
          };
          resolve(obj);
        });
      });
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.dialogVisible = true;
    },
    operateSummary() {
      let loadingObj = Loading.service({
        lock: true,
        text: "汇总评分可能需要3-5分钟，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      // 汇总的时候有的专家可能还没有提交评分 如果一个都没有提交是不允许汇总的
      qryNotSubmitScoreExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.listData[this.active].packId,
        scoreItem: this.type == 0 ? "0" : this.evaForm == "1" ? "" : "1"
      })
        .then(res => {
          loadingObj.close();
          if (res.data.data.expertSubmitFlag != "1") {
            this.$router.push({
              name: "operateSkillOrCommonSummary",
              query: {
                type: this.type,
                packId: this.listData[Number(this.active)].packId,
                a: this.$router.history.current.query.a,
                menuKey: this.$router.history.current.query.menuKey,
                active: this.active
              }
            });
          } else {
            this.$message({
              message: "没有专家提交评分，不能进行汇总，请先进行评分提交！",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        })
        .catch(() => {
          loadingObj.close();
        });
    },
    // 撤销评分
    dealExpertSupScoreCancel() {
      this.$confirm(
        "您确定要撤销专家评分吗？撤销后，需专家重新提交评分？",
        "撤销评分",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "ccui-message-box-custom"
        }
      )
        .then(() => {
          dealExpertSupScoreCancelApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            scoreType: this.type == 0 ? 0 : this.evaForm == "1" ? 2 : 1
          }).then(res => {
            if (res.data.code == "0") {
              this.refresh();
              this.$message({
                message: "撤销评分成功！",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
            }
            // this.$router.push({
            //   name:
            //     this.type == 0
            //       ? "technicalScoreSummary"
            //       : "summaryBusinessSkillsScores",
            //   query: {
            //     a: this.$router.history.current.query.a,
            //     menuKey: this.$router.history.current.query.menuKey
            //   }
            // });
          });
        })
        .catch(() => {});
    },
    // 提交
    dealSumScoreSubmit() {
      // 汇总的时候有的专家可能还没有提交评分 如果存在没有评分是不允许提交的
      qryNotSubmitScoreExpertListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.listData[this.active].packId,
        scoreItem: this.type == 0 ? "0" : this.evaForm == "1" ? "" : "1"
      }).then(res => {
        if (res.data.data.expertSubmitFlag != "3") {
          this.$confirm(
            `评标专家：“${res.data.data.expertNames}”还未提交评分表，您是否确定要提交汇总表？汇总表提交后，此信息将不允许重新汇总。`,
            "提交汇总",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "ccui-message-box-custom"
            }
          )
            .then(() => {
              dealSumScoreSubmitApi({
                schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                  .schemeId,
                sumScoreType: this.type == 0 ? 0 : 2
              }).then(res => {
                this.$message({
                  message: "汇总表提交成功！",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
                // this.$router.push({
                //   name:
                //     this.type == 0
                //       ? "technicalScoreSummary"
                //       : "summaryBusinessSkillsScores",
                //   query: {
                //     a: this.$router.history.current.query.a,
                //     menuKey: this.$router.history.current.query.menuKey
                //   }
                // });
                this.refresh();
              });
            })
            .catch(() => {});
        } else {
          dealSumScoreSubmitApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            sumScoreType: this.type == 0 ? 0 : 2
          }).then(res => {
            this.$message({
              message: "汇总表提交成功！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            // this.$router.push({
            //   name:
            //     this.type == 0
            //       ? "technicalScoreSummary"
            //       : "summaryBusinessSkillsScores",
            //   query: {
            //     a: this.$router.history.current.query.a,
            //     menuKey: this.$router.history.current.query.menuKey
            //   }
            // });
            this.refresh();
          });
        }
      });
    },
    // 刷新
    refresh() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.active = "0";
        this.getData();
        this.reload();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: red;
  padding: 20px 0 0 20px;
}
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
</style>
